import script from "./Emp.vue?vue&type=script&setup=true&lang=js"
export * from "./Emp.vue?vue&type=script&setup=true&lang=js"

import "./Emp.vue?vue&type=style&index=0&id=0dd3ac88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd3ac88"]])

export default __exports__